module.exports = __webpack_public_path__ + "img/panya-logo.60f23aa1.png";